import {pathBuilder} from "../../../anwendungskonfigurator/misc/utils"

export const ApplicationActions = ({navigate, loadCurrentLocationData}) => {
    return {
        UWP_INIT_ROUTING: () => {
            loadCurrentLocationData("/").then(response => {
                navigate(pathBuilder(response._links.suche))
            })
        },
        NAVIGIERE_BACK: () => {
            navigate(-1)
        },
    }
}
